import React, { useState } from 'react';
import { Plus, Trash2, Bell } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import Modal from '../../components/common/Modal';
import Badge from '../../components/common/Badge';
import { formatDate, generateId } from '../../utils/helpers';

function Announcements() {
  const { announcements, setAnnouncements } = useApp();
  const { currentUser } = useAuth();
  const isAdmin = currentUser?.role === 'admin' || currentUser?.role === 'teacher';
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ title:'', content:'', targetRoles:['student','parent','teacher'], priority:'medium', isActive:true });

  const visible = announcements.filter(a => a.isActive && (a.targetRoles.includes('all') || a.targetRoles.includes(currentUser?.role)));
  const remove = (id) => { if(window.confirm('Delete?')) setAnnouncements(prev=>prev.filter(a=>a.id!==id)); };

  const save = () => {
    const newAnn = { ...form, id:generateId('ANN'), createdBy:currentUser?.profileId||'STF-001', createdAt:new Date().toISOString() };
    setAnnouncements(prev=>[newAnn,...prev]);
    setModal(false);
    setForm({ title:'', content:'', targetRoles:['student','parent','teacher'], priority:'medium', isActive:true });
  };

  const toggleRole = (role) => setForm(f=>({...f, targetRoles:f.targetRoles.includes(role)?f.targetRoles.filter(r=>r!==role):[...f.targetRoles,role]}));

  const priorityIcon = { high:'🔴', medium:'🟡', low:'🟢' };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Announcements</h1><p className="text-gray-500 text-sm">{visible.length} active announcements</p></div>
        {isAdmin && <button onClick={()=>setModal(true)} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>New Announcement</button>}
      </div>
      <div className="space-y-4">
        {visible.map(ann=>(
          <div key={ann.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3 flex-1">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0"><Bell size={18} className="text-indigo-600"/></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold">{ann.title}</h3>
                    <span className="text-sm">{priorityIcon[ann.priority]}</span>
                    <Badge value={ann.priority}/>
                  </div>
                  <p className="text-sm mb-2">{ann.content}</p>
                  <div className="flex items-center gap-3">
                    <span>{new Date(ann.createdAt).toLocaleString('en-IN', { dateStyle:'medium', timeStyle:'short' })}</span>
                    <span>For: {ann.targetRoles.join(', ')}</span>
                  </div>
                </div>
              </div>
              {isAdmin && <button onClick={()=>remove(ann.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-400 ml-2"><Trash2 size={15}/></button>}
            </div>
          </div>
        ))}
        {visible.length===0 && <div className="bg-white rounded-xl p-8 text-center">No announcements</div>}
      </div>
      <Modal isOpen={modal} onClose={()=>setModal(false)} title="New Announcement" size="lg">
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-1">Title</label>
            <input value={form.title||''} onChange={e=>setForm(f=>({...f,title:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Content</label>
            <textarea rows={4} value={form.content||''} onChange={e=>setForm(f=>({...f,content:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 resize-none" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Target Audience</label>
            <div className="flex gap-3">
              {['admin','teacher','student','parent'].map(role=>(
                <label key={role} className="flex items-center gap-1.5 cursor-pointer">
                  <input type="checkbox" checked={form.targetRoles.includes(role)} onChange={()=>toggleRole(role)} className="w-4 h-4 accent-indigo-600" />
                  <span className="text-sm capitalize">{role}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Priority</label>
            <select value={form.priority||'medium'} onChange={e=>setForm(f=>({...f,priority:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              {['high','medium','low'].map(p=><option key={p}>{p}</option>)}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Post</button>
        </div>
      </Modal>
    </div>
  );
}
export default Announcements;
